import { Suspense, type ReactNode } from "react"
import { AccountLayout } from "@/components/account/account-layout"
import { getSession } from "@/services/auth-service"

async function MinhaContaShell({ children }: { children: ReactNode }) {
  const session = await getSession()
  return <AccountLayout user={session?.user ?? null}>{children}</AccountLayout>
}

export default function MinhaContaLayout({ children }: { children: ReactNode }) {
  return (
    <Suspense fallback={<AccountLayout user={null}>{children}</AccountLayout>}>
      <MinhaContaShell>{children}</MinhaContaShell>
    </Suspense>
  )
}
